import { render, staticRenderFns } from "./main2.vue?vue&type=template&id=7e0f4136&scoped=true&"
import script from "./main2.vue?vue&type=script&lang=js&"
export * from "./main2.vue?vue&type=script&lang=js&"
import style0 from "./main2.vue?vue&type=style&index=0&id=7e0f4136&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0f4136",
  null
  
)

export default component.exports